import { render, staticRenderFns } from "./OrderOccupy.vue?vue&type=template&id=ed21d7fc&scoped=true"
import script from "./OrderOccupy.vue?vue&type=script&lang=js"
export * from "./OrderOccupy.vue?vue&type=script&lang=js"
import style0 from "./OrderOccupy.vue?vue&type=style&index=0&id=ed21d7fc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed21d7fc",
  null
  
)

export default component.exports